import {Button} from "@/components/ui/button.tsx";
import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyTitle,
} from "@/components/ui/empty.tsx";
import {useNavigate} from "react-router-dom";

export function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<div className="mx-auto flex w-full max-w-lg min-w-0 p-6">
			<Empty className="w-full border border-border">
				<EmptyHeader>
					<EmptyTitle>404</EmptyTitle>
					<EmptyDescription>
						Такой страницы нет. Проверьте адрес или вернитесь на главный раздел.
					</EmptyDescription>
				</EmptyHeader>
				<Button type="button" onClick={() => navigate("/plans")}>
					К планам
				</Button>
			</Empty>
		</div>
	);
}
